import React, { Component } from 'react';
import gmrm from 'googlemaps-rich-marker-web';
import SvgPin from '../assets/HSS_Pin';

import { TweenLite } from 'gsap';

import arts from '../assets/icons/Arts';
import bridge from '../assets/icons/Bridge';
import building from '../assets/icons/Building';
import marketFair from '../assets/icons/MarketFair';
import park from '../assets/icons/Park';
import religiousStructure from '../assets/icons/ReligiousStructure';

import style from './pin.module.scss';

class Pin extends Component {
  componentDidMount() {
    this.initMarker();
  }

  componentWillMount() {
    this.pin = null;
  }

  setIsActive = isActive => {
    if (!this.pinContentDOMNode) return;
    let z = isActive ? 2 : 1;

    //wait to set z-index until all transitions are mostly over
    setTimeout(() => {
      this.pin.setZIndex(z);
    }, 480);

    if (isActive) {
      this.pinContentDOMNode.classList.remove(style.UNVISITED);
      this.pinContentDOMNode.classList.add(style.OPEN);
    } else {
      if (this.pinContentDOMNode.classList.contains(style.OPEN)) {
        this.pinContentDOMNode.classList.add(style.VISITED);
      }
      this.pinContentDOMNode.classList.remove(style.OPEN);
    }
  };

  componentWillUnmount() {
    this.pin.setMap(null);
    this.props.Maps.event.clearListeners(this.pin, 'click');
    if (this.tween) this.tween.kill();
  }

  initMarker = () => {
    const { Maps, map } = this.props;
    if (Maps && map) {
      this.pinContentId = `pin-${this.props.index}`;
      this.pinContent = `<div id="${this.pinContentId}" class="${
        style.UNVISITED
      } ${
        this.props.type === 'Default' ? style.SMALL : ''
      }" style="height: 49px; width: 34px">
        <svg viewBox="0 0 34 49" xmlns="http://www.w3.org/2000/svg" class="${
          style.pin
        }">
          <path d="M17 0C7.601 0 0 7.668 0 17.15 0 30.013 17 49 17 49s17-18.988 17-31.85C34 7.669 26.399 0 17 0z" />
        </svg>
        <div class="${style.contentContainer}">
          <div class="${style.iconContainer}">
            ${
              this.props.type !== 'Default'
                ? this.getIconByType(this.props.type)
                : ''
            }
          </div>
          <div class="${style.titleContainer}">
            <h2 class="${style.title}">${this.props.title}</h2>
          </div>
        </div>
      </div>`;

      this.pin = new gmrm.RichMarker({
        anchor: gmrm.RichMarkerPosition.BOTTOM,
        position: new Maps.LatLng(this.props.lat, this.props.lng),
        content: this.pinContent,
        shadow: false,
        map: map,
      });

      // this.pin.setMap(map);

      this.pin.addListener('ready', () => {
        if (typeof document !== undefined) {
          this.pinContentDOMNode = document.getElementById(this.pinContentId);

          TweenLite.set(this.pinContentDOMNode, { autoAlpha: 0, y: -100 });
          this.tween = TweenLite.to(this.pinContentDOMNode, 1.23, {
            autoAlpha: 1,
            y: 0,
            ease: Expo.easeInOut,
            delay: 0.05 * this.props.index,
            force3D: true,
            onComplete: () => {
              this.setIsActive(this.props.isActive);
            },
          });
        }
      });

      this.pin.addListener('click', event => {
        this.props.handleMarkerClicked(event, this.props.id);
      });
    }
  };

  getIconByType = type => {
    switch (type) {
      case 'Arts':
        return arts;
      case 'Bridge':
        return bridge;
      case 'Building':
        return building;
      case 'MarketFair':
        return marketFair;
      case 'Park':
        return park;
      case 'ReligiousStructure':
        return religiousStructure;
      default:
        return null;
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isActive !== this.props.isActive) {
      this.setIsActive(this.props.isActive);
    }
  }

  render() {
    return null;
  }
}

export default Pin;



// WEBPACK FOOTER //
// ./src/components/tour/map/Pin.js